import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

import { OfferTranslations, OfferTranslationsUpdateRequest } from './offer-translations.types';
import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<OfferTranslations>()(
  EntityStoreKey.OfferTranslations,
  {
    customActions: adapter => ({
      fetchTranslations: (
        state,
        payload: {
          offerId: number;
          targetLangCode: string;
        },
      ) => adapter.markAsPending(state),

      fetchTranslationsSuccess: (state, payload: OfferTranslations) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      fetchTranslationsFailed: (state, err: string) => adapter.setError(state, Error(err)),

      updateTranslations: (
        state,
        payload: {
          offerId: number;
          offer: OfferTranslationsUpdateRequest;
        },
      ) => adapter.markAsPending(state),
      updateTranslationsSuccess: (state, payload: OfferTranslations) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      updateTranslationsFailed: (state, err: string) => adapter.setError(state, Error(err)),
    }),
  },
);

export {
  actions as OfferTranslationsActions,
  selectors as OfferTranslationsSelectors,
  reducer as OfferTranslationsReducer,
  namespace as OfferTranslationsNamespace,
};
